import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles/category.css';
import { ECategoryType } from '../../../../repositories/subscriptions/entities/entities/CategorySchema';
import { TActiveScreen } from '../../../../store/activeScreen';
import { ICategory, IIsActiveCategoryParams } from '../../../../store/categories';
import { Toggle } from '../../../base/Toggle';
import { Chevron } from '../../../base/icons';

//TODO: разобраться со стилями свг
//TODO: добавить свойства onClick и isSelected

export interface ICategoryStoreProps {
  currentCategoryName: string | null;
}

export interface ICategoryDispatchProps {
  changeActiveScreen(activeScreen: TActiveScreen): void;
  getSubscriptionList(categoryName: string): void;
  onChange(params: IIsActiveCategoryParams): void;
}

export type ICategoryOwnProps = ICategory;

export type ICategoryProps = ICategoryStoreProps & ICategoryDispatchProps & ICategoryOwnProps;

export function Category({
  currentCategoryName,
  categoryName,
  title,
  subtitle,
  isActive,
  hasItems,
  categoryType,
  categoryId,
  getSubscriptionList,
  onChange,
  changeActiveScreen,
}: ICategoryProps) {
  let actionComponent: React.ReactNode = '';

  if (hasItems) {
    actionComponent = <Chevron style={{ transform: 'rotate(-90deg)' }} />;
  } else {
    if (categoryType === ECategoryType.Toggle) {
      const params = { categoryName, isActive, categoryId, categoryTitle: title };

      actionComponent = (
        <Toggle className={styles['toggle']} defaultChecked={isActive} onChange={() => onChange(params)} />
      );
    }
  }

  return (
    <div
      className={cx(
        styles['category'],
        !hasItems && categoryType === ECategoryType.Toggle && styles['category--toggle'],
        currentCategoryName === categoryName && styles['selected'],
      )}
      onClick={() => {
        if (hasItems) {
          getSubscriptionList(categoryName);
          changeActiveScreen('subscriptions');
        }
      }}
    >
      <div>
        <div>{title}</div>
        {subtitle && <div className={styles['subtitle']}>{subtitle}</div>}
      </div>

      {actionComponent}
    </div>
  );
}
